import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Modal from 'components/modal_wrapper';

const LoginAlertModal = ({ loginAlert, setLoginAlert, onContinue }) => (
  <>
    {loginAlert && (
      <Modal
        id="login-alert-modal"
        show={Boolean(loginAlert)}
        onHide={() => setLoginAlert(null)}
      >
        <Modal.Header>
          <Modal.Title>Important notice</Modal.Title>
        </Modal.Header>
        <Modal.Body className="content">{parse(loginAlert)}</Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-100">
            <a
              className="btn btn-outline-grey me-2"
              href={`${ecom.craftConfig.api_prefix}/account/logout`}
            >
              Cancel
            </a>
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={onContinue}
            >
              Agree and continue
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )}
  </>
);

LoginAlertModal.propTypes = {
  loginAlert: PropTypes.string,
  setLoginAlert: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default LoginAlertModal;
